import { format } from "date-fns";
import { DataGrid } from "devextreme-react";
import {
  Column,
  ColumnChooser,
  Grouping,
  GroupPanel,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { MovementTypeColumn } from "./MovementTypeColumn";
import React from "react";
import { PriceListTransactionRecordDto } from "../../../dtos/transactions/PriceListTransactionRecordDto";

interface IProps {
  items: PriceListTransactionRecordDto[];
}

export const PriceListTransactionTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <div className={"overflow-auto"}>
        <DataGrid
          dataSource={items}
          sorting={{ mode: "multiple" }}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          showBorders={false}
          showRowLines={true}
          allowColumnResizing={true}
          selection={{ mode: "single" }}
          loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        >
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} />
          <Grouping autoExpandAll={false} />

          <Column width={150} dataField={"companyName"} dataType="string" />

          <Column
            width={75}
            dataField={"companyId"}
            dataType="string"
            caption={"Company"}
          />

          <Column
            width={75}
            dataField={"period"}
            dataType="date"
            caption={"Period"}
          />
          <Column
            width={150}
            dataField={"productId"}
            dataType="string"
            caption={"Product"}
          />
          <Column
            width={100}
            dataField={"unitId"}
            dataType="string"
            caption={"Unit"}
          />

          <Column
            width={100}
            dataField={"price"}
            dataType="number"
            format={"fixedPoint"}
          />

          <Column
            width={100}
            dataField={"priceTypeId"}
            dataType="string"
            caption={"PriceType"}
          />

          <Column
            width={100}
            dataField={"currencyId"}
            dataType="string"
            caption={"Currency"}
          />

          <Column
            width={75}
            dataField={"vatAmount"}
            dataType="number"
            caption={"fixedPoint"}
          />

          <Column
            width={100}
            dataField={"priceWithVat"}
            dataType="number"
            format={"fixedPoint"}
          />

          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={10} />
        </DataGrid>
      </div>
    </>
  );
};
